import { render, staticRenderFns } from "./DonorSummary.vue?vue&type=template&id=c845d1e0&"
import script from "./DonorSummary.vue?vue&type=script&lang=ts&"
export * from "./DonorSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/components/_locales/common.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2FdeceasedDonors%2FDonorSummary.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "./_locales/common.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2FdeceasedDonors%2FDonorSummary.vue"
if (typeof block1 === 'function') block1(component)
import block2 from "../_locales/Organs.json?vue&type=custom&index=2&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2FdeceasedDonors%2FDonorSummary.vue"
if (typeof block2 === 'function') block2(component)
import block3 from "./_locales/DonorSummary.json?vue&type=custom&index=3&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2FdeceasedDonors%2FDonorSummary.vue"
if (typeof block3 === 'function') block3(component)
import block4 from "./_locales/commonPatientShared.json?vue&type=custom&index=4&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2FdeceasedDonors%2FDonorSummary.vue"
if (typeof block4 === 'function') block4(component)
import block5 from "@/components/allocations/_locales/_AllocationDetails.json?vue&type=custom&index=5&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2FdeceasedDonors%2FDonorSummary.vue"
if (typeof block5 === 'function') block5(component)
import block6 from "@/components/deceasedDonors/_locales/DonorInformation.json?vue&type=custom&index=6&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2FdeceasedDonors%2FDonorSummary.vue"
if (typeof block6 === 'function') block6(component)

export default component.exports